"use client";

import useSWR from "swr";

import { API_URLS, MAX_RETRIES } from "./constants";
import { fetcher } from "./utils";

type Questions = {
  uid: string,
  question: string,
  userAnswer: string,
  correctAnswer: string,
  ball: number,
}[];

type Request = {
  error: string,
  questions: Questions,
};

export const useTestReport = ({
  testId,
  enabled,
}: {
  testId: string,
  enabled?: boolean,
}) => {

  return useSWR<Questions>(
    !enabled ? null : [ API_URLS.TEST_REPORT ],
    async () => {
      const lastSession = await fetcher<{ sessionUid: string }>({
        url: API_URLS.TEST_LAST_SESSION,
        params: {
          test: testId,
        },
      }).then((data) => data?.sessionUid);

      const {
        error,
        questions,
      } = await fetcher<Request>({
        url: API_URLS.TEST_REPORT,
        params: {
          session: lastSession!,
        },
      });

      if (error) throw Error(error);
      return questions;
    },
    {
      errorRetryCount: MAX_RETRIES,
    },
  );
};
